import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Download, XCircle } from "lucide-react";
import { API } from "@/lib/api";

export default function Success() {
  const [params] = useSearchParams();
  const token = params.get("token");

  return (
    <div className="pt-28 min-h-screen">
      <div className="max-w-2xl mx-auto px-6 py-20 text-center">
        {token ? (
          <div className="fade-up" data-testid="status-paid">
            <CheckCircle2 className="w-16 h-16 text-primary-gold mx-auto" />
            <h1 className="font-serif-display text-5xl mt-8">Thank you!</h1>
            <p className="text-soft text-lg mt-4">
              Your payment is complete. Download your book below — it's also saved under{" "}
              <Link to="/account" className="text-primary-gold" data-testid="success-account-link">Account</Link> whenever you sign in
              with this PayPal email (after a quick one-time email check), so you can download it again anytime.
            </p>
            <a
              href={`${API}/download/${token}`}
              data-testid="download-link"
              className="btn-gold inline-flex items-center gap-2 px-10 py-4 mt-10 font-mono-ui text-xs uppercase tracking-[0.2em]"
            >
              <Download className="w-4 h-4" /> Download Now
            </a>
            <div className="mt-12">
              <Link
                to="/"
                className="font-mono-ui text-xs uppercase tracking-[0.18em] text-soft hover:text-primary-gold"
              >
                ← Back to the library
              </Link>
            </div>
          </div>
        ) : (
          <div className="fade-up" data-testid="status-failed">
            <XCircle className="w-16 h-16 text-[#d6453a] mx-auto" />
            <h1 className="font-serif-display text-4xl mt-8">Payment not completed</h1>
            <p className="text-soft mt-4">
              It looks like the payment was cancelled or the link is invalid.
            </p>
            <Link
              to="/"
              className="btn-ghost inline-flex px-8 py-4 mt-10 font-mono-ui text-xs uppercase tracking-[0.18em]"
            >
              Return Home
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
